import { render, staticRenderFns } from "./QuotationStepProject.vue?vue&type=template&id=2cffb4fd&scoped=true"
import script from "./QuotationStepProject.vue?vue&type=script&lang=js"
export * from "./QuotationStepProject.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cffb4fd",
  null
  
)

export default component.exports